module.exports = (__webpack_require__(7))(195);


//////////////////
// WEBPACK FOOTER
// delegated ./src/pluginUtils.js from dll-reference girder_plugin_large_image
// module id = 70
// module chunks = 0